import { useSelector } from 'react-redux'

const useIsAuthenticatedWithJwt = () => useSelector(
  state => !!state.account.jwt
)

export default useIsAuthenticatedWithJwt
